import getProjectState from 'store/getProjectState';
import getProjectId from 'utils/url/getProjectId';

import { State, IProjectState } from 'store';

export default function getCurrentProjectState(state: State): IProjectState {
  return getProjectState(state, getProjectId());
}
